import {INotificationTypeStrategy} from '@toolify/client/src/stores/NotificationStore/types/INotificationTypeStrategy'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {IBrowserNotification} from '@toolify/client/src/stores/NotificationStore/types/IBrowserNotification'
import {getNotificationSoundUrl} from '@toolify/client/src/stores/NotificationStore/functions/getNotificationSoundUrl'
import {
  GetMentionedInMessageNotificationTitleByConversationTypeMap,
} from '@toolify/client/src/stores/NotificationStore/maps/GetMentionedInMessageNotificationTitleByConversationTypeMap'
import {NotificationFilterType} from '@toolify/server/src/controllers/NotificationController/enum/NotificationFilterType'
import {DefaultNotificationStrategy} from './DefaultNotificationStrategy'

export class MentionedInMessageNotificationStrategy extends DefaultNotificationStrategy<NotificationType.MentionedInMessage> implements INotificationTypeStrategy {
  getBrowserNotification(notification: INotificationResponseInstance<NotificationType.MentionedInMessage>, authorNick: string): IBrowserNotification {
    const title = GetMentionedInMessageNotificationTitleByConversationTypeMap.get(notification.payload.conversationType)(authorNick, notification.payload)
    const body = notification.payload.truncatedContent
    const sound = getNotificationSoundUrl('new-notification.wav')
    return {
      sound,
      title,
      body,
    }
  }

  getAffectedFilterTypes(notification: INotificationResponseInstance<NotificationType.MentionedInMessage>): NotificationFilterType[] {
    return [
      NotificationFilterType.All,
      NotificationFilterType.Unread,
      NotificationFilterType.Mentions,
    ]
  }

}
